import { Injectable } from '@angular/core';
import { AngularFirestore, CollectionReference } from '@angular/fire/compat/firestore';
import { NotificationService } from '../shared/notification.service';
// import { EventEmitter } from 'events';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
// import { count } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImportTableService {

  // emit = new EventEmitter();

  constructor(private afs: AngularFirestore, private notificationService: NotificationService) {

  }
  async uploadData(path: CollectionReference, requiredColumn, data: Array<{}>, groups: any[] = []) {

    return new Promise(async (res, rej) => {
      try {
        this.notificationService.showSpecificNotification('info', "Uploading in background, Don't refresh.", 'import_table_noti')
        // this.emit.on("error", (err) => {
        //   throw err;
        // })
        if (path) {
          let db = this.afs.firestore;
          let batch = db.batch();
          let counter = 0;
          let docPath;


          for (let i = 0; i < data.length; i++) {


            let result = await this.checkValidation(requiredColumn, data[i]);

            if (!result['success']) {
              // this.emit.emit("error", result)
              break;
            }

            // Optional "group" column: the spreadsheet carries a human-readable
            // group name (not the internal groupId), same as what the manual
            // add-employee dropdown shows. Resolve it against this site's real
            // groups here so a typo doesn't silently create an unlabeled or
            // wrongly-labeled employee.
            const groupLabel = String(data[i]['group'] || '').trim();
            delete data[i]['group'];
            if (groupLabel) {
              const match = groups.find(g =>
                (g.name || '').toLowerCase() === groupLabel.toLowerCase() ||
                (g.groupId || '').toLowerCase() === groupLabel.toLowerCase());
              if (match) {
                data[i]['groupId'] = match.groupId;
              } else {
                this.notificationService.showNotification('error', `"${groupLabel}" is not a group on this site — ${data[i]['name'] || data[i]['email'] || 'row ' + (i + 1)} was skipped`);
                counter += 1;
                continue;
              }
            }

            let duplicate = await path.where('email', '==', data[i]['email']).get()

            if (duplicate.empty) {

              docPath = path.doc();
              console.log(docPath.id)
              data[i]['dbid'] = docPath.id
              data[i]['createdOn'] = moment().unix()
              data[i]['updatedOn'] = moment().unix()


              if (counter % 500 == 0) {
                if (counter > 0) {
                  batch.commit().then(() => this.notificationService.showNotification('info', `${counter} records uploaded`))
                }

                batch = db.batch();
              }


              await batch.set(docPath, data[i]);
              console.log("Not duplicate",data[i]['email'])

            } else {
              console.log("duplicate",data[i]['email'])
              this.notificationService.showNotification('info', `${data[i]['email']} already available`)
            }

            counter += 1;
          }

          if (counter % 500 != 0) {
            batch.commit().then(() => {
              this.notificationService.showNotification('success', "Successfully loaded all!");
              res(true);
            })
          }
        } else {

          for (let i = 0; i < data.length; i++) {
            let result = await this.checkValidation(requiredColumn, data[i]);

            if (!result['success']) {
              // this.emit.emit("error", result)
              break;
            }
            if (i == data.length - 1) {
              res(data)
            }

          }
        }


      } catch (err) {
        console.log(err)
        this.notificationService.showNotification('error', err.message)
        res(false)
      }
    })
  }


  checkValidation(requiredColumn, data) {
    // console.log("requiredColumn",requiredColumn)
    let missing = []

    return new Promise((res, rej) => {

      for (let i = 0; i < requiredColumn.length; i++) {
        if (!(requiredColumn[i]['name'] in data)) {
          missing.push(requiredColumn[i]['name'])
        } else {
          if (requiredColumn[i]['conversion'] === Array) {
            data[requiredColumn[i]['name']] = data[requiredColumn[i]['name']].split(',')
          }
          else if (requiredColumn[i]['conversion'] === Boolean)
            data[requiredColumn[i]['name']] = (data[requiredColumn[i]['name']] == 'true')
          else
            data[requiredColumn[i]['name']] = requiredColumn[i]['conversion'](data[requiredColumn[i]['name']])
        }
      }
      if (missing.length > 0)
        res({ success: false, message: "Please fill " + missing + " fields." });
      else
        res({ success: true, message: "Uploading..." });

    })
  }

}
